<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStoreGetters } from 'dashboard/composables/store';

import Spinner from 'next/spinner/Spinner.vue';

const route = useRoute();
const getters = useStoreGetters();

const uiFlags = getters['integrations/getUIFlags'];
const getIntegration = getters['integrations/getIntegration'];
const customAppId = computed(() => Number(route.params.customAppId));
const customApp = computed(() => {
  const integration = getIntegration.value('wgpt_custom_apps');
  const hooks = integration.hooks ?? [];
  const hook = hooks.find(({ id }) => id === customAppId.value);
  if (!hook) return null;
  return {
    id: hook.id,
    name: hook.settings.name,
    url: hook.settings.url,
  };
});
const isLoading = computed(() => {
  if (!customApp.value) return true;
  return uiFlags.isFetching;
});
</script>

<template>
  <div
    v-if="isLoading"
    class="flex-grow flex-shrink w-full min-w-0 pl-0 pr-0 settings flex flex-col overflow-hidden"
  >
    <section class="w-full flex-1 flex flex-col overflow-hidden">
      <div class="flex items-center justify-center py-10 text-n-slate-11">
        <Spinner />
      </div>
    </section>
  </div>
  <div v-else class="w-full h-full">
    <iframe :src="customApp.url" class="w-full h-full border-0" />
  </div>
</template>
